module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QoYCBACZA4nkwAAAGNJREFUSMdjYBjugBGZk1DbzcvAwPCJFAMWNJcykqKeid4+pLuFLPgkNWVEsYpff/J66Phw1MJhnkqJAQm13f9JKRhGg5QgwFY44CsYRrPFqIWjFo4W3qQ3JUhtbtDdh8MfAABTPxOEA80yygAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/residencial_plurifamiliar.png
// module id = wRmN
// module chunks = 0